import { styled } from 'styled-components'
import { mediaDesktop } from './styles/breakPoints'
import BaseIcon, { LargeIcon } from '@favordelivery/tupperware/lib/components/icons/baseIcon'

const Svg = styled.svg<{ $color?: string }>`
  --primary: ${p => p.theme.color[p.$color || 'background'].primary};
`

export const FavorLogo = ({ ...attrs }) => (
  <Svg {...attrs} $color="background" xmlns="http://www.w3.org/2000/svg" width="167" height="30" viewBox="0 0 167 30">
    <g fill="var(--primary)" fillRule="evenodd">
      <path d="M59.785 3.036h16.599v5.637H66.062v4.314h9.276v5.394h-9.276v9.012h-6.277zM90.403 18.052l-2.267-7.093-2.266 7.093h4.533zm-5.37-15.016h6.346l8.614 24.357h-6.59l-1.43-4.359H84.3l-1.395 4.359h-6.451l8.578-24.357zM97.823 3.036h6.835l4.499 15.085 4.463-15.085h6.696l-8.23 24.357h-6.033zM137.482 15.424v-.384c0-4.21-2.022-6.785-4.917-6.785-2.894 0-4.882 2.54-4.882 6.75v.383c0 4.21 2.023 6.786 4.917 6.786 2.93 0 4.882-2.54 4.882-6.75m-16.215.069v-.522c0-7.272 4.777-12.388 11.333-12.388 6.591 0 11.299 5.046 11.299 12.353v.522c0 7.272-4.778 12.388-11.334 12.388-6.59 0-11.298-5.046-11.298-12.353M156.609 14.866c2.127 0 3.382-1.217 3.382-3.166v-.07c0-2.087-1.325-3.131-3.417-3.131h-3.07v6.367h3.105zm-9.346-11.83h9.59c3.278 0 5.753.87 7.323 2.47 1.36 1.357 2.127 3.237 2.127 5.707v.174c0 3.619-1.779 5.88-4.359 7.168l5.022 8.838h-7.08l-4.148-7.55h-2.233v7.55h-6.242V3.036zM42.59 25.539c-2.467-.503-8.03-1.923-11.559-5.001V17.22h6.533c1.11 0 2.01-.898 2.01-2.006 0-1.107-.9-2.005-2.01-2.005h-6.533V9.892C34.564 6.81 40.134 5.39 42.595 4.89c.986 1.69 2.759 5.412 2.759 10.324 0 4.872-1.78 8.623-2.765 10.325M4.146 15.214c0-4.872 1.781-8.624 2.765-10.325 2.463.499 8.018 1.912 11.557 5.003v3.317h-6.533c-1.11 0-2.01.898-2.01 2.005 0 1.108.9 2.006 2.01 2.006h6.533v3.317C14.936 23.62 9.366 25.04 6.904 25.54c-.986-1.69-2.758-5.413-2.758-10.326M45.158 1.467a2.012 2.012 0 0 0-1.88-.775c-.388.054-8.965 1.297-14.53 5.87a9.667 9.667 0 0 0-3.998-.875 9.669 9.669 0 0 0-4 .876C15.188 1.989 6.61.746 6.223.693c-.721-.1-1.44.195-1.88.774C4.17 1.694.125 7.112.125 15.214c0 8.103 4.044 13.522 4.217 13.748a2.01 2.01 0 0 0 1.88.775c.387-.054 8.965-1.297 14.53-5.87a9.667 9.667 0 0 0 3.998.875 9.669 9.669 0 0 0 3.998-.875c5.564 4.573 14.142 5.816 14.53 5.87a2.013 2.013 0 0 0 1.88-.775c.172-.226 4.216-5.645 4.216-13.748 0-8.102-4.044-13.52-4.216-13.747" />
    </g>
  </Svg>
)

const CheckMarkSC = styled(Svg)`
  margin-top: 22px;
  float: right;
`
export const CheckMark = () => (
  <CheckMarkSC $color="green" xmlns="http://www.w3.org/2000/svg" width="22" height="16" viewBox="0 0 22 16">
    <path
      fill="none"
      fillRule="evenodd"
      stroke="var(--primary)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
      d="M21 1L6 15l-5-5"
    />
  </CheckMarkSC>
)

const ChevronSC = styled(Svg)`
  float: right;
  margin: 23px 0 0 0;
  transform: rotate(-90deg);
`
export const Chevron = () => (
  <ChevronSC xmlns="http://www.w3.org/2000/svg" width="15" height="9" viewBox="0 0 15 9" $color="blue">
    <path
      fill="none"
      fillRule="evenodd"
      stroke="var(--primary)"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="3"
      d="M14 1L7.5 7.5 1 1"
    />
  </ChevronSC>
)

const DefaultIcon = styled.svg`
  float: left;
  --light: var(--themeColorForegroundTint);
  --med: var(--themeColorForegroundDisabled);
  --bg: var(--themeColorBackgroundPrimary);
  --blue: var(--themeColorBluePrimary);
  --lightBlue: var(--themeColorBlueTint25);
`
export const CreateAccountOff = () => (
  <DefaultIcon
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="50"
    height="50"
    viewBox="0 0 50 50"
  >
    <defs>
      <path
        id="createAccountOffPath"
        d="M.382 34.81C4.855 39.267 10.877 42 17.5 42c6.814 0 12.99-2.891 17.5-7.58V0H.382v34.81z"
      />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="var(--light)" d="M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25" />
      <g transform="translate(7.5 7.167)">
        <mask id="createAccountOffMask" fill="var(--bg)">
          <use xlinkHref="#createAccountOffPath" />
        </mask>
        <path
          fill="var(--bg)"
          stroke="var(--med)"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="1.5"
          d="M.382 42.833H35v-7.187s-2.812-3.251-6.77-4.976c-3.959-1.726-6.529-2.28-6.529-2.28v-5.036s1.424-.972 2.327-2.43c.902-1.459.798-3.611.798-3.611s1.424-.209 1.424-2.431-1.458-2.361-1.458-2.361 2.272-5.439.763-7.778c-1.006-1.562-5.069-2.674-8.194-2.257-3.097.413-4.062 1.621-4.803 2.506-.193.23-.49.356-.784.289-.371-.084-.985-.04-1.809.642-1.653 1.371.244 6.598.244 6.598s-1.459.139-1.459 2.36c0 2.223 1.424 2.431 1.424 2.431s-.105 2.153.798 3.611c.903 1.459 2.327 2.431 2.327 2.431v5.035s-2.57.555-6.528 2.281c-3.958 1.725-6.39 4.976-6.39 4.976v7.187z"
          mask="url(#createAccountOffMask)"
        />
      </g>
      <circle cx="25" cy="25" r="24" stroke="var(--light)" strokeWidth="2" />
    </g>
  </DefaultIcon>
)

export const CompleteApplicationOff = () => (
  <DefaultIcon xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path fill="var(--light)" d="M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25" />
      <path
        fill="var(--bg)"
        stroke="var(--med)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M14.236 38.846h21.527V12.268H14.237z"
      />
      <path fill="var(--bg)" d="M27.513 10.667a2.513 2.513 0 1 0-5.026 0h-2.71v3.198h10.445v-3.198h-2.709z" />
      <path
        fill="var(--bg)"
        stroke="var(--med)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="1.5"
        d="M27.513 10.667a2.513 2.513 0 1 0-5.026 0h-2.71v3.198h10.445v-3.198h-2.709z"
      />
      <path stroke="var(--light)" strokeWidth="2" d="M18 18h14M18 22h14M18 26h14M18 30h14M18 34h14" />
    </g>
  </DefaultIcon>
)

export const CompleteApplicationOn = () => (
  <DefaultIcon xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path fill="var(--lightBlue)" d="M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25" />
      <path fill="var(--bg)" stroke="var(--blue)" strokeWidth="1.5" d="M14.236 38.846h21.527V12.268H14.237z" />
      <path fill="var(--bg)" d="M27.513 10.667a2.513 2.513 0 1 0-5.026 0h-2.71v3.198h10.445v-3.198h-2.709z" />
      <path
        stroke="var(--blue)"
        strokeWidth="1.5"
        d="M27.513 10.667a2.513 2.513 0 1 0-5.026 0h-2.71v3.198h10.445v-3.198h-2.709z"
      />
      <path stroke="var(--lightBlue)" strokeWidth="2" d="M18 18h14M18 22h14M18 26h14M18 30h14M18 34h14" />
    </g>
  </DefaultIcon>
)

export const DownloadAppOn = () => (
  <DefaultIcon xmlns="http://www.w3.org/2000/svg" width="50" height="50" viewBox="0 0 50 50">
    <g fill="none" fillRule="evenodd">
      <path fill="var(--lightBlue)" d="M50 25c0 13.807-11.193 25-25 25S0 38.807 0 25 11.193 0 25 0s25 11.193 25 25" />
      <path
        fill="var(--bg)"
        stroke="var(--blue)"
        strokeWidth="1.5"
        d="M33.807 38.376a2.816 2.816 0 0 1-2.816 2.816H19.01a2.816 2.816 0 0 1-2.816-2.816V11.624a2.816 2.816 0 0 1 2.816-2.816H30.99a2.816 2.816 0 0 1 2.816 2.816v26.752z"
      />
      <path stroke="var(--blue)" strokeWidth="1.5" d="M33.807 34.526H16.193M33.807 15.82H16.193M21.825 12.314h6.35" />
      <path fill="var(--blue)" d="M25.26 38.908a1.25 1.25 0 1 1 0-2.5 1.249 1.249 0 1 1 0 2.5" />
      <path stroke="var(--lightBlue)" strokeWidth="1.5" d="M20.133 25h9.734M21.428 21.126h7.144M20.996 28.874h8.008" />
    </g>
  </DefaultIcon>
)

const PhoneSC = styled.svg`
  margin-top: 30px;
  --bg: var(--themeColorBackgroundPrimary);
  --blue: var(--themeColorBluePrimary);
  --lightBlue: var(--themeColorBlueTint25);
  ${mediaDesktop} {
    display: none;
  }
`
export const Phone = () => (
  <PhoneSC
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="140"
    height="185"
    viewBox="0 0 140 185"
  >
    <defs>
      <path d="M139.999 85.638C139.752 123.988 108.507 155 70 155 31.493 155 .248 123.988.001 85.638L0 0h140v85.638z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <path fill="var(--lightBlue)" d="M140 85c0 38.66-31.34 70-70 70S0 123.66 0 85s31.34-70 70-70 70 31.34 70 70z" />
      <mask fill="var(--bg)">
        <use xlinkHref="#a" />
      </mask>
      <path
        fill="var(--bg)"
        d="M32.774 158.013h74.478V21.114H32.774v136.899zm37.242 17.558a6.655 6.655 0 0 1-6.647-6.647 6.655 6.655 0 0 1 6.647-6.647 6.655 6.655 0 0 1 6.647 6.647 6.655 6.655 0 0 1-6.647 6.647zM57.119 9.552a1.76 1.76 0 1 1-.002 3.52 1.76 1.76 0 0 1 .002-3.52zm7.12.759h11.547a1 1 0 1 1 0 2H64.239a1 1 0 1 1 0-2zm5.774-5.171a1.15 1.15 0 1 1 0 2.301 1.15 1.15 0 0 1 0-2.301zM102.097 2H37.93c-6.212 0-11.266 5.053-11.266 11.265v155.042c0 6.212 5.054 11.266 11.266 11.266h64.167c6.212 0 11.265-5.054 11.265-11.266V13.265C113.362 7.053 108.309 2 102.097 2z"
        mask="url(#b)"
      />
      <path
        fill="var(--blue)"
        d="M64.24 12.311h11.546a1 1 0 1 0 0-2H64.24a1 1 0 1 0 0 2M57.119 13.07a1.76 1.76 0 1 0-.001-3.519 1.76 1.76 0 0 0 .001 3.52M70.013 7.443a1.15 1.15 0 1 0 0-2.302 1.15 1.15 0 0 0 0 2.302"
        mask="url(#b)"
      />
      <path
        fill="var(--blue)"
        d="M113.362 168.307c0 6.212-5.054 11.266-11.266 11.266H37.93c-6.212 0-11.265-5.054-11.265-11.266V13.265C26.664 7.053 31.717 2 37.93 2h64.167c6.212 0 11.266 5.054 11.266 11.266v155.042zm2-133.008V13.265c0-7.314-5.95-13.266-13.266-13.266H37.93c-7.314 0-13.265 5.952-13.265 13.266v8.491a2.392 2.392 0 0 0-1.422 2.185v1.348c0 .976.585 1.811 1.422 2.185v7.81a2.394 2.394 0 0 0-1.422 2.185v6.623c0 .976.585 1.812 1.422 2.185v3.205a2.392 2.392 0 0 0-1.422 2.185v6.623c0 .975.585 1.811 1.422 2.185v107.832c0 7.314 5.951 13.266 13.265 13.266h64.167c7.315 0 13.266-5.952 13.266-13.266V46.263a2.391 2.391 0 0 0 1.395-2.17v-6.624a2.39 2.39 0 0 0-1.395-2.17z"
        mask="url(#b)"
      />
      <path
        fill="var(--blue)"
        d="M70 61.284c13.287 0 24.058 8.453 24.058 18.881S83.288 99.047 70 99.047c-1.799 0-3.549-.16-5.235-.454l-14.039 3.913v-11.04c-3.005-3.15-4.784-7.063-4.784-11.3 0-10.429 10.771-18.882 24.058-18.882zm-37.226 96.73h74.478v-136.9H32.774v136.9z"
        mask="url(#b)"
      />
      <path
        fill="var(--bg)"
        d="M50.725 91.467v11.039l14.04-3.912c1.686.293 3.436.453 5.236.453 13.285 0 24.056-8.453 24.056-18.881s-10.77-18.881-24.056-18.881c-13.288 0-24.059 8.453-24.059 18.88 0 4.239 1.78 8.15 4.783 11.302z"
        mask="url(#b)"
      />
      <path fill="var(--bg)" fillOpacity=".1" d="M32.774 158.013v-136.9h74.478z" mask="url(#b)" />
      <circle cx="61.5" cy="80.5" r="3.5" fill="var(--blue)" mask="url(#b)" />
      <circle cx="70.5" cy="80.5" r="3.5" fill="var(--blue)" mask="url(#b)" />
      <circle cx="79.5" cy="80.5" r="3.5" fill="var(--blue)" mask="url(#b)" />
    </g>
  </PhoneSC>
)

const CheckSC = styled.svg`
  --bg: var(--themeColorBackgroundPrimary);
  --blue: var(--themeColorBluePrimary);
  --lightBlue: var(--themeColorBlueTint25);
  ${mediaDesktop} {
    margin-top: 78px;
  }
`
export const EncircledCheck = () => (
  <CheckSC
    xmlns="http://www.w3.org/2000/svg"
    xmlnsXlink="http://www.w3.org/1999/xlink"
    width="130"
    height="130"
    viewBox="0 0 130 130"
  >
    <defs>
      <path d="M65 130c35.899 0 65-29.101 65-65S100.899 0 65 0 0 29.101 0 65s29.101 65 65 65z" />
    </defs>
    <g fill="none" fillRule="evenodd">
      <g>
        <use fill="var(--bg)" xlinkHref="#a" />
        <path
          stroke="var(--lightBlue)"
          d="M65 129.5c35.622 0 64.5-28.878 64.5-64.5S100.622.5 65 .5.5 29.378.5 65s28.878 64.5 64.5 64.5z"
        />
      </g>
      <path
        stroke="var(--blue)"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="3"
        d="M89.733 48L53.467 82 41 69.533"
      />
    </g>
  </CheckSC>
)

// for nav menu in tablet/mobile view
export const MenuIcon = props => (
  <BaseIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2 5.5C2 4.67157 2.67157 4 3.5 4H20.5C21.3284 4 22 4.67157 22 5.5C22 6.32843 21.3284 7 20.5 7H3.5C2.67157 7 2 6.32843 2 5.5ZM2 12.5C2 11.6716 2.67157 11 3.5 11H14.5C15.3284 11 16 11.6716 16 12.5C16 13.3284 15.3284 14 14.5 14H3.5C2.67157 14 2 13.3284 2 12.5ZM3.5 18C2.67157 18 2 18.6716 2 19.5C2 20.3284 2.67157 21 3.5 21H10.5C11.3284 21 12 20.3284 12 19.5C12 18.6716 11.3284 18 10.5 18H3.5Z"
      fill="var(--primaryColor"
    />
  </BaseIcon>
)

// to close the nav menu
export const CloseIcon = props => (
  <BaseIcon {...props}>
    <path
      d="M18.295 7.115C18.6844 6.72564 18.6844 6.09436 18.295 5.705C17.9056 5.31564 17.2744 5.31564 16.885 5.705L12.1768 10.4132C12.0791 10.5109 11.9209 10.5109 11.8232 10.4132L7.115 5.705C6.72564 5.31564 6.09436 5.31564 5.705 5.705C5.31564 6.09436 5.31564 6.72564 5.705 7.115L10.4132 11.8232C10.5109 11.9209 10.5109 12.0791 10.4132 12.1768L5.705 16.885C5.31564 17.2744 5.31564 17.9056 5.705 18.295C6.09436 18.6844 6.72564 18.6844 7.115 18.295L11.8232 13.5868C11.9209 13.4891 12.0791 13.4891 12.1768 13.5868L16.885 18.295C17.2744 18.6844 17.9056 18.6844 18.295 18.295C18.6844 17.9056 18.6844 17.2744 18.295 16.885L13.5868 12.1768C13.4891 12.0791 13.4891 11.9209 13.5868 11.8232L18.295 7.115Z"
      fill="var(--primaryColor)"
    />
  </BaseIcon>
)

// for footer
export const Bowtie = props => (
  <LargeIcon {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17.5354 31.2358C16.2289 31.826 14.8201 32.2871 13.4102 32.6316C12.9542 32.743 12.5288 32.8345 12.1438 32.9075C12.1284 32.8823 12.1126 32.8562 12.0963 32.8292C11.8017 32.3396 11.5053 31.7683 11.2279 31.1227C10.4332 29.274 9.95652 27.2145 9.95652 25.0001C9.95652 22.7857 10.4332 20.7261 11.2279 18.8773C11.5053 18.2318 11.8017 17.6604 12.0963 17.1708C12.1126 17.1439 12.1284 17.1178 12.1438 17.0925C12.5288 17.1656 12.9542 17.2571 13.4102 17.3685C14.8201 17.713 16.2289 18.1741 17.5354 18.7643C18.9085 19.3846 20.0824 20.1108 21 20.9424V24H16.1111C15.5588 24 15.1111 24.4477 15.1111 25C15.1111 25.5523 15.5588 26 16.1111 26H21V29.0576C20.0824 29.8892 18.9085 30.6154 17.5354 31.2358ZM21.9935 30.8206C20.9665 31.6878 19.7299 32.431 18.3263 33.0651C16.9008 33.7091 15.3823 34.206 13.8651 34.5768C13.3346 34.7064 12.8412 34.8112 12.3971 34.8934C12.127 34.9434 11.9304 34.9751 11.8195 34.9907C11.4716 35.0396 11.1248 34.8942 10.9107 34.6096C10.527 34.0994 9.97855 33.1881 9.43662 31.9273C8.53881 29.8386 8 27.5106 8 25.0001C8 22.4896 8.53881 20.1615 9.43661 18.0728C9.97855 16.812 10.527 15.9006 10.9107 15.3905C11.1248 15.1059 11.4716 14.9604 11.8195 15.0093C11.9304 15.0249 12.127 15.0567 12.3971 15.1067C12.8412 15.1889 13.3346 15.2936 13.8651 15.4233C15.3823 15.794 16.9008 16.291 18.3263 16.935C19.7963 17.599 21.0831 18.3828 22.1378 19.3033C22.2265 19.2579 22.321 19.2123 22.4209 19.1669C23.2004 18.8127 24.0667 18.6 24.9999 18.6C25.9332 18.6 26.7995 18.8127 27.5791 19.1668C27.679 19.2122 27.7734 19.2579 27.8622 19.3033C28.9169 18.3828 30.2037 17.599 31.6737 16.935C33.0992 16.291 34.6177 15.794 36.1349 15.4233C36.6654 15.2936 37.1588 15.1889 37.6029 15.1067C37.873 15.0567 38.0696 15.0249 38.1805 15.0093C38.5284 14.9604 38.8752 15.1059 39.0893 15.3905C39.473 15.9006 40.0215 16.812 40.5634 18.0728C41.4612 20.1615 42 22.4896 42 25.0001C42 27.5106 41.4612 29.8386 40.5634 31.9273C40.0215 33.1881 39.473 34.0994 39.0893 34.6096C38.8752 34.8942 38.5284 35.0396 38.1805 34.9907C38.0696 34.9751 37.873 34.9434 37.6029 34.8934C37.1588 34.8112 36.6654 34.7064 36.1349 34.5768C34.6177 34.206 33.0992 33.7091 31.6737 33.0651C30.2701 32.431 29.0335 31.6878 28.0065 30.8206C27.8778 30.8907 27.7352 30.9623 27.5791 31.0332C26.7995 31.3873 25.9332 31.6 24.9999 31.6C24.0667 31.6 23.2004 31.3873 22.4209 31.0332C22.2648 30.9623 22.1222 30.8907 21.9935 30.8206ZM29 24V20.9424C29.9176 20.1108 31.0915 19.3846 32.4646 18.7643C33.7711 18.1741 35.1799 17.713 36.5898 17.3685C37.0458 17.2571 37.4712 17.1656 37.8562 17.0925C37.8716 17.1178 37.8874 17.1439 37.9037 17.1708C38.1983 17.6604 38.4947 18.2318 38.7721 18.8773C39.5668 20.7261 40.0435 22.7857 40.0435 25.0001C40.0435 27.2145 39.5668 29.274 38.7721 31.1227C38.4947 31.7683 38.1983 32.3396 37.9037 32.8292L37.877 32.8733L37.8562 32.9075C37.4712 32.8345 37.0458 32.743 36.5898 32.6316C35.1799 32.2871 33.7711 31.826 32.4646 31.2358C31.0915 30.6154 29.9176 29.8892 29 29.0576V26H33.8889C34.4412 26 34.8889 25.5523 34.8889 25C34.8889 24.4477 34.4412 24 33.8889 24H29Z"
      fill="var(--primaryColor)"
    />
  </LargeIcon>
)
